module.exports = __webpack_public_path__ + "img/bgimg.0dc71721.png";